import React from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { Clear as ClearIcon } from '@mui/icons-material';

interface ColorPickerProps {
  value: string;
  onChange: (color: string) => void;
  onClear?: () => void;
  disabled?: boolean;
  label?: string;
  helperText?: string;
}

export const ColorPicker: React.FC<ColorPickerProps> = ({
  value,
  onChange,
  onClear,
  disabled = false,
  label,
  helperText,
}) => {
  return (
    <Box>
      {label && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
          {label}
        </Typography>
      )}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Tooltip title={disabled ? '' : 'Click to change color'}>
          <Box
            component="input"
            type="color"
            value={value || '#808080'}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
            disabled={disabled}
            sx={{
              width: '100%',
              height: 36,
              cursor: disabled ? 'not-allowed' : 'pointer',
              border: 'none',
              borderRadius: 1,
              opacity: disabled ? 0.5 : 1,
              '&::-webkit-color-swatch-wrapper': {
                padding: 0,
              },
              '&::-webkit-color-swatch': {
                border: '1px solid rgba(0,0,0,0.2)',
                borderRadius: 4,
              },
            }}
          />
        </Tooltip>
        {onClear && value && !disabled && (
          <Tooltip title="Clear color">
            <IconButton size="small" onClick={onClear}>
              <ClearIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Box>
      {helperText && (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
          {helperText}
        </Typography>
      )}
    </Box>
  );
};
